import { useEffect, useRef, useState } from "react";
import { otherConfigOptionsAttributesFeature } from "../../configSetupScreen/widget/configBottomBar";
import { useSelector } from "react-redux";
import store from "../../../../../stateManagement/store";
import "./FeatureSelectionComponent.css"
import { appSubscriptionCheck, appSubscriptionCheckNew, setAppSubscription, setClientConfigRef } from "../../../../../services/uiConfigService";
import { Height } from "@material-ui/icons";


type FeatureSelectionProps = {
  featureList: otherConfigOptionsAttributesFeature[];
  setSubFeature: (id: otherConfigOptionsAttributesFeature) => void;
  subFeature:otherConfigOptionsAttributesFeature|undefined
};
export default function FeatureSelectionComponent({ featureList,
  setSubFeature,subFeature
}: FeatureSelectionProps)
{
  
  
 
const savedRole: any = useSelector(() => store.getState().roleState.role);
  const savedAppType: any = useSelector(() => store.getState().appTypeState.appType);

  const clientConfigRef = useRef<any[]>([]);
  const [isLoader, setIsloader] = useState<boolean>(false);
  const [standard, setStandard] = useState<string | undefined>(undefined);

  const [selectedFeature, setSelectedFeature] = useState<otherConfigOptionsAttributesFeature | null>(null);

  // Init
  useEffect(() => {
    const init = async () => {
      await setClientConfigRef(clientConfigRef, setIsloader);
      setAppSubscription(setStandard, clientConfigRef.current);
    };
    init();
  }, []);

  // Filter feature list
  const filteredFeatures = featureList.filter(
    (option) =>
      option.isDeveloped &&
      (option.isSelected || option.isMandatory) &&
      appSubscriptionCheckNew(option, standard)
  );
  useEffect(()=>{
    if(filteredFeatures.length>0&&featureList.length>0&&filteredFeatures[0].id!=featureList[0].id&&subFeature==featureList[0]){
      setSubFeature(filteredFeatures[0])
    }
  },[filteredFeatures])

  // featureList=featureList.filter((obj : any) => obj?.supportedAppTypes?.includes(savedAppType?.id));  
 


    return (
        <>
    <div className="featureSelectionComponentMained">
        <div className="featureSelectionComponentouter" >
            {filteredFeatures.map((feature)=>
                <button   className={
              subFeature?.id === feature.id
                ? "featureSelectionComponentSelectedbutton"
                : "featureSelectionComponentbutton"
            } onClick={()=>{setSubFeature(feature)
                }} key={feature.id}>{feature.id}</button>
            )}
        </div>
        </div>
 
     
        </>
    )
}